import { IMapLayer } from "../../shared/models/map_models";
import { AppDispatch } from "../../shared/store";
import { IMapFilter, IMapFilterParam, MapQueryParams } from "./map-models";
import { setMapLayerVisibility } from "./map-slice";

export const getQueryParam = (key: string): string | null => {
  return new URLSearchParams(window.location.search).get(key);
};

export const setQueryParam = (key: string, value: string): void => {
  const params = new URLSearchParams(window.location.search);
  params.set(key, value);
  const newUrl = `${window.location.pathname}?${params.toString()}`;
  window.history.replaceState({}, '', newUrl);
};


export const handleLayerState = (layerState: Array<IMapLayer>, dispatch: AppDispatch, layerId?: number) => {
  const visibleLayers = getQueryParam(MapQueryParams.VisibleLayers)
  let splitVisibleLayers: Array<string> | null = null
  if (visibleLayers) splitVisibleLayers = visibleLayers.split(",")
  const updatedVisibleLayers: Array<number> = []

  if (layerId !== undefined){
      const inParam = splitVisibleLayers?.find((x) => Number(x) === layerId)
      layerState.forEach((x) => {
          if (x.id === layerId){
              if (!inParam){
                  updatedVisibleLayers.push(x.id)
              }
          } else if (x.visible){
              updatedVisibleLayers.push(x.id)
          }
      })
      dispatch(setMapLayerVisibility(layerId))
  } else {
      layerState.forEach((layer) => {
          const foundLayer = splitVisibleLayers?.find((x) => Number(x) === layer.id)
          if (splitVisibleLayers && splitVisibleLayers?.length !== 0){
              if (foundLayer && layer.visible)
                  updatedVisibleLayers.push(layer.id)
              else if (!foundLayer && layer.visible)
                  dispatch(setMapLayerVisibility(layer.id))
          } else {
              if (layer.visible)
                  updatedVisibleLayers.push(layer.id)
          }
      })
  }

  setQueryParam(MapQueryParams.VisibleLayers, updatedVisibleLayers.join(","))
}

export const getFilterStateFromParams = (): Array<IMapFilterParam> => {
  const currentFilterParams = getQueryParam(MapQueryParams.FilterValues)
  if (currentFilterParams === null)
    return []
  else {
    const formattedParams = JSON.parse(currentFilterParams) || []
    const formattedFilterParamList: Array<IMapFilterParam> = []
    formattedParams.forEach((filterParam: string) => {
      const splitParam = filterParam.split(":")
      formattedFilterParamList.push({
        filterId: Number(splitParam[0]), 
        filterValue: splitParam[1]
      })
    })

    return formattedFilterParamList
  }
}


export const putMapFilterInParam = (filter: IMapFilter) => {
  const filtersInParam = getFilterStateFromParams()
  const updatedFilterParams: Array<string> = []
  if (filtersInParam.length === 0){
      updatedFilterParams.push(`${filter.id}:${filter.value}`)
  }
  else {
    let filterExists = false
    filtersInParam.forEach((x) => {
      if(x.filterId === filter.id){
        filterExists = true
        updatedFilterParams.push(`${x.filterId}:${filter.value}`)
      } else{
         updatedFilterParams.push(`${x.filterId}:${x.filterValue}`)
      }
    })

    if (!filterExists)
      updatedFilterParams.push(`${filter.id}:${filter.value}`)
  }

  setQueryParam(MapQueryParams.FilterValues, JSON.stringify(updatedFilterParams))
}